import {
  GenericDataType,
  SearchField,
  SingleValueSearchField,
  StringComparator,
} from 'modules/domains';

import { ElementType, useElementIndex } from '../../contexts';
import { useRequirementState } from '../useRequirementState';

const DEFAULT_CONDITION: SingleValueSearchField = {
  comparatorType: StringComparator.EQUALS,
  dataType: GenericDataType.User,
  field: '',
  value: '',
};

export const useCondition = (): SearchField => {
  const [requirement] = useRequirementState();
  const conditionIndex = useElementIndex(ElementType.Condition);
  return requirement.searchCombo.searchQueries[conditionIndex] ?? DEFAULT_CONDITION;
};
